import styled from "styled-components/macro";

const StyledSelectContainer = styled.div`
  position: relative;
  box-sizing: border-box;
  font-size: var(--size-font-small);
`;

export const SelectContainer = ({ innerProps, children }: any) => (
  <StyledSelectContainer data-testid="SelectContainer" {...innerProps}>
    {children}
  </StyledSelectContainer>
);

type StyledOptionProps = {
  isFocused: boolean;
};

const StyledOption = styled.div<StyledOptionProps>`
  padding: 0.5em 1em;
  white-space: nowrap;
  color: var(--color-primary-700);
  height: 1.5em;
  line-height: 1.5em;
  ${(props) =>
    props.isFocused && {
      background: "var(--color-secondary-200)",
    }}
  &:hover {
    cursor: pointer;
    background: var(--color-secondary-200);
  }
`;

type OptionProps = {
  children: any;
  isFocused: boolean;
  data: {
    route?: string;
  };
  innerProps: object;
};

export const Option = ({
  children,
  innerProps,
  isFocused,
  data,
}: OptionProps) => (
  <StyledA data-testid="NavBarOption" href={data.route ? data.route : "#"}>
    <StyledOption data-testid="Option" {...innerProps} isFocused={isFocused}>
      {children}
    </StyledOption>
  </StyledA>
);

const StyledMenu = styled.div`
  top: 108%;
  background-color: hsl(0, 0%, 100%);
  border: 1px solid rgba(34, 36, 38, 0.15);
  border-top: none;
  border-radius: 5px;
  box-shadow: 2px 3px 8px rgba(0, 0, 0, 20%);
  margin-bottom: 8px;
  margin-top: -4px;
  position: absolute;
  width: auto;
  min-width: 100%;
  z-index: 10000;
  box-sizing: border-box;
  [class*="LeftQueue"] & {
    left: -9px;
  }
  [class*="RightQueue"] & {
    right: -16px;
  }
`;

export const Menu = ({ children, innerProps }: any) => (
  <StyledMenu {...innerProps}>{children}</StyledMenu>
);

const StyledMenuList = styled.div`
  overflow-y: auto;
`;

export const MenuList = ({ children, innerProps }: any) => (
  <StyledMenuList {...innerProps}>{children}</StyledMenuList>
);

const StyledControl = styled.div`
  background-color: "transparent";
  display: flex;
  flex-wrap: wrap;
  position: relative;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  & > div {
    padding-bottom: 0;
    padding-top: 0;
  }
`;

export const Control = ({ children, innerProps }: any) => (
  <StyledControl {...innerProps}>{children}</StyledControl>
);

const StyledPlaceHolder = styled.div`
  color: #e6e6e6;
  font-weight: var(--font-weight-regular);
  letter-spacing: normal;
  padding: 0px;
`;

export const Placeholder = ({ children }: any) => (
  <StyledPlaceHolder>{children}</StyledPlaceHolder>
);

const StyledDropdownIndicator = styled.div`
  color: #e6e6e6;
  line-height: 1;
  padding-left: 3px;
  &:after {
    content: "▾";
  }
`;

export const DropdownIndicator = () => <StyledDropdownIndicator />;

const StyledA = styled.a`
  text-decoration: none;
`;
